import { render, staticRenderFns } from "./StudentPlaces.vue?vue&type=template&id=a38dd0c6&scoped=true"
import script from "./StudentPlaces.vue?vue&type=script&lang=js"
export * from "./StudentPlaces.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38dd0c6",
  null
  
)

export default component.exports